import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './rewardingform.cssmodule.scss';
import { Radio, FormGroup, Panel, Button, Accordion, Collapse} from 'react-bootstrap';
import Select from 'react-select';
var NotificationSystem = require('react-notification-system');
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';



class RewardingForm extends React.Component {
  constructor(props) {
    super(props);
    const { ideaId } = props;

    this.state = {
       open : false,
       reward : {
         CostCenterId : 1,
         ConsultedWithOriginator : false,
         IsPaymentOrderPrinted : false,
         DecidedRewardAmount : 0, 
         Comment : '',
         Approved : false,
         SafetyReward : 0,
         QualityReward : 0,
         CostSavingReward : 0,
         EnvironmentReward : 0
       }
    };
  }

  componentDidMount() {
       const { ideaId } = this.props;
       const { reward } = this.props;       
       this.setState({
         reward : { 
          ...reward, 
          InitiativeId : ideaId}
      });
      this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) { 
      const { ideaId } = nextProps;
      const { reward } = nextProps;
      this.setState({reward : {...reward, InitiativeId : ideaId}});
  }

  

  rewardChange(prop ,event){
    this.state.reward[prop] = parseInt(event.target.value);

    const totalReward = (this.state.reward.SafetyReward ? this.state.reward.SafetyReward : 0) + 
                              (this.state.reward.QualityReward ? this.state.reward.QualityReward : 0) + 
                              (this.state.reward.CostSavingReward ? this.state.reward.CostSavingReward : 0) + 
                              (this.state.reward.EnvironmentReward ? this.state.reward.EnvironmentReward : 0);


    const reward = {...this.state.reward,
                   DecidedRewardAmount : totalReward, 
                   Dirty : true, 
                  };
    this.setState({reward : reward});
  }

  submitReward(){
    const {inWorkFlow} = this.props;
    const { actions } = this.props;
    const { ideaId } = this.props;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    if(!inWorkFlow)
      return;
    actions.saveRewardAction(ideaId, {...this.state.reward, Approved : true}).then(() => {
      this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('SAVE_REWARD_OK'),
              level: 'success',
              position : 'br'
        });
      actions.fetchInitiativeJournalsAction(ideaId);
    });
  }


  printReport(){
      const {inWorkFlow} = this.props;
      const { actions } = this.props;
      const {rewardReportURL} =  this.props;
      const { ideaId } = this.props;
      const {reward} = this.state;
      if(inWorkFlow && reward.Dirty){
        actions.saveRewardAction(ideaId, {...reward, Approved : false}).then(() => {
          window.open(rewardReportURL, '_blank');
        });  
      }else{
          window.open(rewardReportURL, '_blank');
      }
  }

  canApprove(){
    const {inWorkFlow} = this.props;
    const {reward} = this.state;
    return (inWorkFlow && reward.DecidedRewardAmount && reward.ConsultedWithOriginator && reward.Comment && reward.CostCenterId && reward.IsPaymentOrderPrinted);
  }

  canPrint(){
    const {reward} = this.state;
    return (reward.DecidedRewardAmount && reward.Comment && reward.CostCenterId);
  }

  onChangeRewardProp(propertyName, event){
    var value = typeof event === 'object' ? event.target.value : event;
    if(propertyName === 'ConsultedWithOriginator' || propertyName === 'IsPaymentOrderPrinted'){
       value = event.target.checked ? true : false;
    }
    const reward = {...this.state.reward, [propertyName] : value, Dirty : true};
    this.setState({
      reward : reward
    });
  }

  resetRewardTable(){
     const reward = {...this.state.reward, DecidedRewardAmount : 0, 
      SafetyReward : 0,
      QualityReward : 0,
      CostSavingReward : 0,
      EnvironmentReward : 0,
      Dirty : true
    };
    this.setState(
    {
      reward : reward
    });

  }

  saveRewardDraft(){
      const {inWorkFlow} = this.props;
      const { actions } = this.props;
      const {rewardReportURL} =  this.props;
      const { ideaId } = this.props;
      const {reward} = this.state;
      const {intl} = this.props;
      const t = (message, data = {}) => {
          if(!message) return '';
          return intl.formatMessage({id : message}, data);
      };
      
      if(inWorkFlow && reward.Dirty){
        actions.saveRewardAction(ideaId, {...reward, Approved : false}).then(() => {
          this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('SAVE_REWARD_OK'),
              level: 'success',
              position : 'br'
          });
        });  
      }
      else
      {
          this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('SAVE_REWARD_OK'),
              level: 'success',
              position : 'br'
          });
      }
  }


  render() {
    const {costCenters} = this.props;
    const {reward} = this.state;
    const {inWorkFlow} = this.props;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    return (
      <div className="rewardingform-component table-responsive" styleName="rewardingform-component">
        <NotificationSystem ref="notificationSystem" />
        {
          inWorkFlow && <Button className="btn-brand" onClick={ ()=> this.setState({ open: !this.state.open })}>
              {t(this.state.open ? 'Hide reward calculator' : 'Show reward calculator')}
            </Button>
        }
        
        <Collapse in={this.state.open} style={{marginTop : '5px'}}>
          <div>
            <table className="table table-bordered" style={{marginTop : '5px'}}>
              <thead>
                <tr>
                  <th></th>
                  <th>{t('REWARD.OWN_STATION')}</th>
                  <th>{t('REWARD.OWN_DEPARTMENT')}</th>
                  <th>{t('REWARD.OWN_BUSINESS_UNIT')}</th>   
                  <th>{t('REWARD.GLOBAL')}</th>
                </tr>
              </thead>
              <tbody>
                  <tr>
                      <td><strong>{t('REWARD.SAFETY')}</strong></td>
                      <td> <Radio checked={this.state.reward.SafetyReward == 250}  onChange={this.rewardChange.bind(this,'SafetyReward')} value="250"  name="safetyReward">250 {t('Euro')}</Radio>
                        {t('REWARD.SAFETY_COL1')}
                      </td>
                      <td> <Radio checked={this.state.reward.SafetyReward == 800} onChange={this.rewardChange.bind(this,'SafetyReward')}  value="800"  name="safetyReward">800 {t('Euro')}</Radio>
                        {t('REWARD.SAFETY_COL2')}
                      </td>
                      <td> <Radio checked={this.state.reward.SafetyReward == 4000}  onChange={this.rewardChange.bind(this,'SafetyReward')}  value="4000"  name="safetyReward">4000 {t('Euro')}</Radio>
                      {t('REWARD.SAFETY_COL3')}
                      </td>
                      <td> <Radio checked={this.state.reward.SafetyReward == 10000} onChange={this.rewardChange.bind(this,'SafetyReward')}  value="10000"  name="safetyReward">10000 {t('Euro')}</Radio>
                        {t('REWARD.SAFETY_COL4')}
                      </td>
                  </tr>
                  <tr>
                      <td><strong>{t('REWARD.QUALITY')}</strong></td>
                      <td><Radio   checked={this.state.reward.QualityReward == 250} onChange={this.rewardChange.bind(this,'QualityReward')}  value="250"  name="qualityReward">250 {t('Euro')}</Radio>
                        {t('REWARD.QUALITY_COL1')}
                      </td>
                      <td> <Radio checked={this.state.reward.QualityReward == 800}  onChange={this.rewardChange.bind(this,'QualityReward')}  value="800"  name="qualityReward">800 {t('Euro')}</Radio>
                          {t('REWARD.QUALITY_COL2')}
                      </td>
                      <td> <Radio checked={this.state.reward.QualityReward == 4000} onChange={this.rewardChange.bind(this,'QualityReward')}   value="4000"  name="qualityReward">4000 {t('Euro')}</Radio>
                        {t('REWARD.QUALITY_COL3')}
                      </td>
                      <td> <Radio checked={this.state.reward.QualityReward == 10000}  onChange={this.rewardChange.bind(this,'QualityReward')}  value="10000"  name="qualityReward">10000 {t('Euro')}</Radio>
                        {t('REWARD.QUALITY_COL4')}
                      </td>
                  </tr>
                  <tr>
                      <td><strong>{t('REWARD.EFFECTIVENESS')}</strong></td>
                      <td><Radio checked={this.state.reward.CostSavingReward == 250} onChange={this.rewardChange.bind(this,'CostSavingReward')}  value="250"  name="costSavingReward">250 {t('Euro')}</Radio>
                        {t('REWARD.EFFECTIVENESS_COL1')}
                      </td>
                      <td><Radio checked={this.state.reward.CostSavingReward == 800} onChange={this.rewardChange.bind(this,'CostSavingReward')} value="800"  name="costSavingReward">800 {t('Euro')}</Radio>
                        {t('REWARD.EFFECTIVENESS_COL2')}
                      </td>
                      <td><Radio checked={this.state.reward.CostSavingReward == 4000}  onChange={this.rewardChange.bind(this,'CostSavingReward')} value="4000"  name="costSavingReward">4000 {t('Euro')}</Radio>
                        {t('REWARD.EFFECTIVENESS_COL3')}
                      </td>
                      <td><Radio checked={this.state.reward.CostSavingReward == 10000} onChange={this.rewardChange.bind(this,'CostSavingReward')} value="10000"  name="costSavingReward">10000 {t('Euro')}</Radio>
                        {t('REWARD.EFFECTIVENESS_COL4')}
                      </td>
                  </tr>
                  <tr>
                      <th><strong>{t('REWARD.ENVIRONMENT')}</strong></th>
                      <td><Radio  checked={this.state.reward.EnvironmentReward == 250}  onChange={this.rewardChange.bind(this,'EnvironmentReward')} value="250"  name="environmentReward">250 {t('Euro')}</Radio>
                        {t('REWARD.ENVIRONMENT_COL1')}
                      </td>
                      <td><Radio  checked={this.state.reward.EnvironmentReward == 800} onChange={this.rewardChange.bind(this,'EnvironmentReward')} value="800"  name="environmentReward">800 {t('Euro')}</Radio>
                        {t('REWARD.ENVIRONMENT_COL2')}
                      </td>
                      <td><Radio checked={this.state.reward.EnvironmentReward == 4000}  onChange={this.rewardChange.bind(this,'EnvironmentReward')} value="4000"  name="environmentReward">4000 {t('Euro')}</Radio>
                        {t('REWARD.ENVIRONMENT_COL3')}
                      </td>
                      <td><Radio checked={this.state.reward.EnvironmentReward == 10000} onChange={this.rewardChange.bind(this,'EnvironmentReward')} value="10000"  name="environmentReward">10000 {t('Euro')}</Radio>
                        {t('REWARD.ENVIRONMENT_COL4')}
                      </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </Collapse>
        <form className="form-horizontal form-condensed">
              <div className="form-group noMarginLeftRight">
                <label className="col-sm-3 control-label">{t('Reward sum')}  :</label>
                <div className="col-sm-9">
                    <p className="form-control-static">{reward.DecidedRewardAmount} {t('Euros')} &nbsp; 
                      {
                        inWorkFlow && <button onClick={this.resetRewardTable.bind(this)} type="button" className="btn btn-default btn-brand btn-sm"><i className="glyphicon glyphicon-remove"/> {t('Clear')}</button>
                      }

                    </p>
                </div>
              </div>

              <div className="form-group noMarginLeftRight">
                <label className="col-sm-3 control-label">{t('Comment')} :</label>
                <div className="col-sm-9">
                   <textarea disabled={!inWorkFlow} rows="4" className="form-control" value={reward.Comment} onChange={this.onChangeRewardProp.bind(this, 'Comment' )}/>
                </div>
              </div>


                  
              <div className="checkbox">
                  <label className="col-sm-2 control-label"></label>
                  <div className="col-sm-10"><input type="checkbox" disabled={!inWorkFlow} checked = {reward.ConsultedWithOriginator} onChange={this.onChangeRewardProp.bind(this, 'ConsultedWithOriginator' )}/><small>
                    {t('REWARD_CONSULTED')}</small></div>
              </div>
              <div className="form-group noMarginLeftRight">
                <label className="col-sm-3 control-label">* {t('Cost center')} :</label>
                <div className="col-sm-9">
                    <Select
                          disabled={!inWorkFlow}
                          value={reward.CostCenterId}
                          options={costCenters.CostCenters}
                          onChange={(c)=> {this.setState({reward :{...reward, CostCenterId : c ? c.Id : null, Dirty : true}})}}
                          style={{maxWidth : '400px'}}
                          clearable = "false"
                        />
                </div>
              </div>
              <div className="form-group noMarginLeftRight">
                <label className="col-sm-3 control-label">{t('Rewarding template')} :</label>
                <div className="col-sm-9">
                    <button type="button" disabled={!this.canPrint.bind(this)()} className="btn btn-default btn-brand btn-sm" onClick={this.printReport.bind(this)}>
                      {t('Print')}</button>
                </div>
              </div>
               <div className="checkbox">
                   <label className="col-sm-2 control-label"></label>
                   <div className="col-sm-10"><input disabled={!inWorkFlow} type="checkbox" checked = {reward.IsPaymentOrderPrinted} onChange={this.onChangeRewardProp.bind(this, 'IsPaymentOrderPrinted')}/><small>
                     {t('REWARD_SENT')}</small></div>
              </div>
              

              {
              inWorkFlow && <button type="button" disabled={!this.canApprove.bind(this)()} onClick={this.submitReward.bind(this)} className="btn btn-default btn-brand pull-right">
                {t('Approve')}
              </button>
              }

              {
              inWorkFlow && <button type="button" style={{marginRight : "5px"}} onClick={this.saveRewardDraft.bind(this)} className="btn btn-default btn-brand pull-right">
                {t('Save Draft')}
              </button>
              }

        </form>
      </div>
    );
  }
}

RewardingForm.displayName = 'RewardingForm';
RewardingForm.propTypes = {};
RewardingForm.defaultProps = {};

export default injectIntl(cssmodules(RewardingForm, styles));



// WEBPACK FOOTER //
// ./components/ProcessIdeas/RewardingForm.js